import { action, makeObservable, observable, reaction } from 'mobx';
import { RouterPagesStore } from './routerPages';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import {
    AppSystem,
    ICompaniesHashSettingList,
    ICompaniesHierarchyAPI,
    ICompaniesList,
    IFilterParams,
    ISelect,
} from '../interfaces';
import { getCompaniesList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class CompaniesStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const RouterPagesStoreInstance = RouterPagesStore.getInstance();
                const appSystem = RouterPagesStoreInstance.appSystem;
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getCompaniesList(cleanParams, appSystem === AppSystem.BILLING).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: CompaniesStore;
    public static getInstance(): CompaniesStore {
        if (!CompaniesStore.instance) {
            CompaniesStore.instance = new CompaniesStore();
        }
        return CompaniesStore.instance;
    }

    @observable select: ISelect[] = [];
    @action setCompaniesSelect(select: ISelect[]): void {
        this.select = select;
    }

    @observable companiesHashSettingsList: ICompaniesHashSettingList = [];
    @action setCompaniesHashSettingsList(list: ICompaniesHashSettingList): void {
        this.companiesHashSettingsList = list;
    }
    @observable companyTypeSelect: ISelect[] = [];
    @action setCompanyTypeSelect(companyTypeSelect: ISelect[]): void {
        this.companyTypeSelect = companyTypeSelect;
    }

    @observable paymentTypeSelect: ISelect[] = [];
    @action setPaymentTypeSelect(paymentTypeSelect: ISelect[]): void {
        this.paymentTypeSelect = paymentTypeSelect;
    }

    @observable childrenSelect: ISelect[] = [];
    @action setCompaniesChildrenSelect(select: ISelect[]): void {
        this.childrenSelect = select;
    }

    @observable list: ICompaniesList = [];
    @action setCompaniesList(companiesList: ICompaniesList): void {
        this.list = companiesList;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: true,
        withDeleted: true,
        pageSize: true,
        companyTypeId: true,
        paymentType: true,
        search: true,
    };

    // ------------ companiesHierarchyList ------------
    @observable companiesHierarchyList: Array<ICompaniesHierarchyAPI> = [];

    @action addChildrenCompaniesHierarchyList(
        parentId: string | undefined,
        companiesHierarchyList: Array<ICompaniesHierarchyAPI>,
    ): void {
        this.companiesHierarchyList = [
            ...this.companiesHierarchyList,
            ...companiesHierarchyList.map((l) => ({ ...l, parentId })),
        ];
    }

    @action cleanStore(): void {
        this.list = [];
        this.companiesHierarchyList = [];
        this.childrenSelect = [];
        this.companyTypeSelect = [];
        this.paymentTypeSelect = [];
        this.companiesHashSettingsList = [];
        this.select = [];
    }
}
